<template>
  <div>
    <div class="jumbotron">

      <div class="btn-group pull-right" role="group" aria-label="">
        <button type="button" class="btn btn-sm btn-primary" @click="clickCreateNew" v-if="!loading && success">
          <i class="fas fa-plus-circle"></i> Create
        </button>
        <button type="button" class="btn btn-sm btn-success" @click="clickGuide">
          <i class="fas fa-question"></i> Guide
        </button>
        <button type="button" class="btn btn-sm btn-warning" @click="clickDashboards">
          <i class="fas fa-tachometer-alt"></i> Dashboards
        </button>
        <button type="button" class="btn btn-sm btn-secondary" @click="clickRefresh">
          <i class="fas fa-sync"></i> Refresh
        </button>
      </div>

      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item active">Sync</li>
      </ol>

      <div class="row">
        <div class="col-md-3">
          <div class="card card-inverse card-info text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>View integration details</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-info-circle card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-inverse card-success text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Stream integration logs to your browser</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-history card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-inverse card-warning text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Edit the configuration for an integration</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-edit card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-inverse card-danger text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Disable and remove an integration</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-minus-circle card-block-watermark"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <feedback v-if="showFeedback"
          v-bind:message="feedbackMessage"
          v-bind:spin="showSpinner"
          v-bind:success="success"></feedback>
        <div v-if="!loading && success && rows.length > 0">
          <vue-good-table
              title="Helium Journey Apps"
              :columns="columns"
              :rows="rows"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'appName', type: 'asc'}
              }"
              :search-options="{ enabled: true }"
              :paginationOptions="{ enabled: true }"
              styleClass="vgt-table striped bordered table-hover"
              :lineNumbers="true">
              <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'status'">
                    <div v-if="props.row.status === 'Enabled'">
                      <span class="badge badge-success">
                        <i class="fa fa-play" aria-hidden="true"></i>
                        {{props.row.status}}
                      </span>
                    </div>
                    <div v-if="props.row.status === 'Disabled'">
                      <span class="badge badge-warning">
                        <i class="fa fa-stop" aria-hidden="true"></i>
                        {{props.row.status}}
                      </span>
                    </div>
                    <div v-if="props.row.status === 'Halted'">
                      <span class="badge badge-danger">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{props.row.status}}
                      </span>
                    </div>
                  </span>

                  <span v-if="props.column.field == 'appName'">
                      {{props.row.appName}}
                  </span>

                  <span v-if="props.column.field == 'id'">
                    {{ props.row.id }}
                  </span>

                  <span v-if="props.column.field == 'heliumBaseUrl'">
                  {{ props.row.heliumBaseUrl }}
                  </span>

                  <span v-if="props.column.field == 'journeyBaseUrl'">
                    {{ props.row.journeyBaseUrl }}
                  </span>

                  <span v-if="props.column.field == 'actions'" class="text-right">
                    <div class="btn-group" role="group">
                      <button type="button" class="btn btn-primary btn-sm" @click="selectInfo(props.row)">
                        <i class="fas fa-info-circle"></i> Info
                      </button>
                      <button type="button" class="btn btn-group btn-sm" @click="selectObjectSync(props.row)">
                        <i class="fas fa-arrow-right-arrow-left"></i> Objects
                      </button>
                      <button type="button" class="btn btn-success btn-sm" @click="selectLogs(props.row)">
                        <i class="fas fa-history"></i> Logs
                      </button>
                      <button type="button" class="btn btn-warning btn-sm" @click="selectEdit(props.row)">
                        <i class="fas fa-edit"></i> Edit
                      </button>
                      <button type="button" class="btn btn-danger btn-sm" @click="clickDelete(props.row)">
                        <i class="fas fa-minus-circle"></i> Delete
                      </button>
                    </div>
                  </span>
              </template>
          </vue-good-table>
        </div>
      </div>
    </div>

    <modal :v-if="modalInfoShow" :show.sync="modalInfoShow" :backdrop="modalBackdrop" effect="zoom" large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title" v-if="selection">
          <i class="fa fa-rocket" aria-hidden="true"></i>
           {{selection.appName}}
           <span class="badge badge-default badge-pill">{{selection.id}}</span>
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <ul class="list-group" v-if="selection">
          <li class="list-group-item justify-content-between">
            App ID
            <span class="badge badge-default badge-pill">{{selection.id}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            Helium API URL
            <span class="badge badge-default badge-pill">{{selection.heliumBaseUrl}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            Journey Environment
            <span class="badge badge-default badge-pill">{{selection.journeyEnvironment}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            Journey User
            <span class="badge badge-default badge-pill">{{selection.journeyUserName}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            Journey Password
            <span class="badge badge-default badge-pill">{{selection.journeyPassword}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            Journey Last Sync
            <span class="badge badge-default badge-pill">{{ formatEpoch(selection.journeyLastUpdated) }}</span>
          </li>
          <li class="list-group-item justify-content-between">
            Helium Last Sync
            <span class="badge badge-default badge-pill">{{ formatEpoch(selection.heliumLastUpdated) }}</span>
          </li>
          <li class="list-group-item justify-content-between" v-if="selection.lastPinged && selection.lastPinged != 'null'">
            Last Pinged
            <span class="badge badge-default badge-pill">{{ formatEpoch(selection.lastPinged) }}</span>
          </li>
          <li class="list-group-item justify-content-between">
            Last Helium Version Processed (change-log)
            <span class="badge badge-default badge-pill">{{selection.heliumSyncStatus}}</span>
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <div class="input-group-addon">
                <button type="button" class="btn btn-primary" data-toggle="tooltip"
                  title="Copy Command to Clipboard"
                  v-clipboard:copy="heliumCurl"
                  v-clipboard:success="onCopy">
                  <i class="fa fa-clipboard"></i>
                </button>
              </div>
              <input type="text" class="form-control" id="heliumCurl" v-model="heliumCurl" readonly="readonly">
            </div>
          </li>
          <li class="list-group-item justify-content-between">
            Last Journey Version Processed (op-log)
            <span class="badge badge-default badge-pill">{{selection.journeySyncStatus}}</span>
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <div class="input-group-addon">
                <button type="button" class="btn btn-primary" data-toggle="tooltip"
                  title="Copy Command to Clipboard"
                  v-clipboard:copy="journeyCurl"
                  v-clipboard:success="onCopy">
                  <i class="fa fa-clipboard"></i>
                </button>
              </div>
              <input type="text" class="form-control sm" id="journeyCurl" v-model="journeyCurl" readonly="readonly">
            </div>
          </li>
        </ul>

      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" v-on:click="modalInfoClose">Close</button>
      </div>
    </modal>

    <modal :v-if="modalObjectSyncShow" :show.sync="modalObjectSyncShow" :backdrop="modalBackdrop" effect="zoom" large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title" v-if="selection">
          <i class="fa fa-arrow-right-arrow-left" aria-hidden="true"></i>
           {{selection.appName}}
           <span class="badge badge-default badge-pill">{{selection.id}}</span>
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <feedback v-if="showSyncFeedback"
          v-bind:message="feedbackSyncMessage"
          v-bind:spin="showSyncSpinner"
          v-bind:success="syncSuccess">
        </feedback>
        <vue-good-table
            title="Sync Objects"
            :columns="sync_columns"
            :rows="sync_rows"
            :sort-options="{
              enabled: true,
              initialSortBy: {field: 'objectName', type: 'asc'}
            }"
            :search-options="{ enabled: true }"
            :paginationOptions="{ enabled: true }"
            styleClass="vgt-table striped bordered table-hover"
            :lineNumbers="true">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'platform'">
                    {{props.row.platform}}
                </span>
                <span v-if="props.column.field == 'type'">
                    {{props.row.type}}
                </span>
                <span v-if="props.column.field == 'objectName'">
                    {{props.row.objectName}}
                </span>
                <span v-if="props.column.field == 'objectCount'">
                  {{ props.row.objectCount }}
                </span>
            </template>
        </vue-good-table>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" v-on:click="modalObjectSyncClose">Close</button>
      </div>
    </modal>

    <modal :show.sync="modalLogShow" :backdrop="modalBackdrop" effect="zoom" title="Sync Logs" large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title" v-if="selection">
          <i class="fa fa-rocket" aria-hidden="true"></i> {{selection.appName}} <span class="badge badge-default badge-pill">{{selection.id}}</span>
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <feedback v-if="showLogsFeedback"
          v-bind:message="feedbackLogsMessage"
          v-bind:spin="showLogsSpinner"
          v-bind:success="logsSuccess">
        </feedback>
        <text-editor
          v-bind:contentProp="textBlock"
          v-bind:width="textBlockWidth"
          v-bind:height="textBlockHeight"
          v-bind:readonly="textBlockReadOnly"
          v-bind:scrollToLine="scrollToLine"
          v-bind:lang="textBlockLang">
        </text-editor>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <div class="row">
          <div class="col">
            <fieldset class="form-group">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="autoScrollToBottom" v-model="scrollToLine">
                <label class="form-check-label" for="autoScrollToBottom">Scroll to bottom</label>
              </div>
            </fieldset>
          </div>
        </div>
        <button type="button" class="btn btn-default" @click="modalLogClose">Close</button>
      </div>
    </modal>

    <modal
      :show.sync="modalDeleteShow"
      :backdrop="modalBackdrop"
      effect="zoom"
      large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <i class="fa fa-rocket" aria-hidden="true"></i> Delete Helium Journey Integration
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <form>
          <fieldset>
            <legend>Confirm Delete:</legend>
            <div class="form-group">

              <div class="form-group">
                <div class="input-group">
                  <label class="col-4 col-form-label">App ID</label>
                  <input v-model="heliumAppUuidForDelete"
                    class="form-control"
                    type="text" readonly="">
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <label class="col-4 col-form-label">App Name</label>
                  <input v-model="heliumAppNameForDelete"
                    class="form-control"
                    type="text" readonly="">
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <label class="col-4 col-form-label text-danger">Enter DELETE in capital letters</label>
                  <input v-model="heliumDeleteConfirm"
                    class="form-control"
                    type="text">
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" @click="modalDeleteAction" :disabled="deleteDisabled">Delete</button>
        <button type="button" class="btn btn-default" @click="modalDeleteClose">Close</button>
      </div>
    </modal>

    </div>
  </div>
</template>

<script>
  import Feedback from '@/components/Feedback.vue'
  import { modal } from 'vue-strap'
  import TextEditor from '@/components/TextEditor.vue'
  export default {
    components: {
      Feedback,
      modal,
      TextEditor
    },
    data () {
      return {
        list: [],
        loading: false,
        displayButton: false,
        feedbackMessage: '',
        success: false,
        showSpinner: false,
        showFeedback: false,
        sync_columns: [
          {
            label: 'Platform',
            field: 'platform'
          },
          {
            label: 'Type',
            field: 'type',
            filterable: true
          },
          {
            label: 'Object Name',
            field: 'objectName',
            filterable: true
          },
          {
            label: 'Object Count',
            field: 'objectCount',
            filterable: true
          }
        ],
        columns: [
          {
            label: 'Status',
            field: 'status'
          },
          {
            label: 'Name',
            field: 'appName',
            filterable: true
          },
          {
            label: 'App ID',
            field: 'id',
            filterable: true
          },
          {
            label: 'Helium Base Url',
            field: 'heliumBaseUrl',
            filterable: true
          },
          {
            label: 'Journey Base Url',
            field: 'journeyBaseUrl',
            filterable: true
          },
          {
            label: 'Actions',
            field: 'actions'
          }
        ],
        rows: [
        ],
        sync_rows: [
        ],
        selection: null,
        modalInfoShow: false,
        modalObjectSyncShow: false,
        modalBackdrop: false,
        heliumCurl: null,
        journeyCurl: null,
        syncConfig: null,
        textBlockWidth: 0,
        textBlockHeight: 0,
        textBlockReadOnly: true,
        textBlockLang: 'sql',
        scrollToLine: true,
        logs: [],
        modalLogShow: false,
        showLogsFeedback: false,
        showSyncFeedback: false,
        feedbackLogsMessage: null,
        feedbackSyncMessage: null,
        showLogsSpinner: true,
        showSyncSpinner: true,
        logsSuccess: false,
        syncSuccess: false,
        expand: false,
        modalDeleteShow: false,
        heliumAppUuidForDelete: '',
        heliumDeleteConfirm: '',
        heliumAppNameForDelete: null,
        deleteDisabled: true
      }
    },
    methods: {
      getSyncUrl: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/sync'
        if (vm.$parent.environment.name === 'Zambia-production') {
          endpoint += '-zm'
        } else if (vm.$parent.environment.name !== 'Production') {
          endpoint += '-stb'
        }
        endpoint += '/api/'
        return endpoint
      },
      getList: function () {
        let vm = this
        let endpoint = vm.getSyncUrl() + 'list'
        var config = {}
        config['environment'] = vm.$parent.environment.name
        vm.$parent.loading = true
        vm.loading = true
        vm.feedbackMessage = null
        vm.showFeedback = false
        vm.axios.post(endpoint, config, {
          auth: {
            username: vm.$parent.username,
            password: vm.$parent.password
          }
        })
          .then(function (response) {
            vm.$parent.syncApps = response.data
            vm.rows = vm.$parent.syncApps
            vm.$parent.loading = false
            vm.loading = false
            vm.success = true
            if (vm.rows.length <= 0) {
              vm.feedbackMessage = 'No Helium Journey Integrations found on ' + endpoint
              vm.showFeedback = true
            }
            if (vm.$route.params.appid) {
              let result = vm.$parent.syncApps.find(function (key) {
                return key.id === vm.$route.params.appid
              })
              console.log(result)
              if (result) {
                vm.selectLogs(result)
              }
            }
          })
          .catch(function (error) {
            console.log(error)
            console.log(error.response)
            vm.$parent.loading = false
            vm.loading = false
            if (error.response) {
              vm.feedbackMessage = (error.response.status === 502) ? 'Bad Gateway - Invalid response from the upstream server' : error.response.data
            } else {
              vm.feedbackMessage = error
              console.log(error)
            }
            vm.success = false
            vm.showFeedback = true
          })
      },
      selectInfo: function (selection) {
        // console.log(selection)
        let vm = this
        vm.modalInfoShow = true
        vm.selection = selection
        vm.heliumCurl = 'curl -X GET -u "d4ec6977-28ab-4caf-8872-edd39b471436:29Z47X436" '
        vm.heliumCurl += selection.heliumBaseUrl + '/api/data/v1/' + selection.id + '/change-log?version='
        vm.heliumCurl += selection.heliumSyncStatus
        vm.heliumCurl += ' | python -mjson.tool'
        vm.journeyCurl = 'curl -X GET -u "' + selection.journeyUserName + ':' + selection.journeyPassword + '" "' + selection.journeyBaseUrl + '/api/v4/' + selection.journeyUserName + '/oplog?start=' + selection.journeySyncStatus + '&skip_source=api" | python -mjson.tool'
      },
      selectObjectSync: function (selection) {
        let vm = this
        vm.modalObjectSyncShow = true
        vm.feedbackSyncMessage = 'Fetching objects'
        vm.showSyncSpinner = true
        vm.showSyncFeedback = true
        vm.syncSuccess = true
        vm.selection = selection
        vm.heliumCurl = selection.heliumBaseUrl + '/api/data/v1/' + selection.id + '/change-log?version=' + selection.heliumSyncStatus
        vm.journeyCurl = selection.journeyBaseUrl + '/api/v4/' + selection.journeyUserName + '/oplog?start=' + selection.journeySyncStatus + '&skip_source=api'
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/get-sync-objects'
        let config = {}
        config['heliumUsername'] = 'd4ec6977-28ab-4caf-8872-edd39b471436'
        config['heliumPassword'] = '29Z47X436'
        config['heliumUrl'] = vm.heliumCurl
        config['journeyUrl'] = vm.journeyCurl
        config['journeyUsername'] = selection.journeyUserName
        config['journeyPassword'] = selection.journeyPassword
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.$parent.syncObjects = response.data
            vm.sync_rows = vm.$parent.syncObjects
            vm.showSyncSpinner = false
            vm.showSyncFeedback = false
          })
          .catch(function (error) {
            console.log(error)
            console.log(error.response)
            if (error.response) {
              vm.feedbackSyncMessage = (error.response.status === 502) ? 'Bad Gateway - Invalid response from the upstream server' : error.response.data
            } else {
              vm.feedbackSyncMessage = error
              console.log(error)
            }
          })
      },
      selectEdit: function (selection) {
        let vm = this
        vm.selection = selection
        vm.$router.push({name: 'SyncForm', params: {appid: vm.selection.id}})
      },
      selectLogs: function (selection) {
        let vm = this
        let wsUrl = vm.$parent.httpUrlToWebSockeUrl(vm.getSyncUrl() + '/ws')
        vm.$parent.socket = new WebSocket(wsUrl)
        vm.modalLogShow = true
        vm.selection = selection
        vm.feedbackLogsMessage = 'Opening websocket connection to ' + wsUrl
        if (selection.status === 'Disabled') {
          vm.feedbackLogsMessage = 'Integration Disabled'
          vm.showLogsSpinner = false
          vm.showLogsFeedback = true
          vm.logsSuccess = true
          vm.logs.push('Integration is disabled logs cannot be streamed')
          return
        }
        vm.$parent.socket.onopen = function () {
          vm.$parent.socket.onmessage = function (response) {
            // console.log(response.data)
            var json = JSON.parse(response.data)
            vm.logs.push(json.value)
            vm.feedbackLogsMessage = 'Streaming Logs...'
            vm.showLogsSpinner = true
            vm.showLogsFeedback = true
            vm.logsSuccess = true
          }
          vm.$parent.socket.onclose = function (response) {
            vm.showLogsSpinner = false
            vm.showLogsFeedback = true
            vm.logsSuccess = false
            if (response.code === 1006) {
              vm.feedbackLogsMessage = vm.feedbackLogsMessage + ' ' + 'The connection was closed abnormally, e.g., without sending or receiving a Close control frame (RFC 6455 - The WebSocket Protocol)'
            }
          }
          let websocketRequest = {}
          websocketRequest['appId'] = selection.id
          websocketRequest['type'] = 'LOG_SESSION'
          websocketRequest['config'] = null
          vm.$parent.socket.send(JSON.stringify(websocketRequest))
        }
      },
      modalInfoClose: function () {
        let vm = this
        vm.modalInfoShow = false
        vm.getList()
      },
      modalObjectSyncClose: function () {
        let vm = this
        vm.sync_rows = []
        vm.modalObjectSyncShow = false
        vm.showSyncFeedback = false
        vm.showSyncSpinner = false
        vm.getList()
      },
      modalLogClose: function () {
        let vm = this
        let doPush = vm.modalLogShow
        vm.modalLogShow = false
        vm.logs = []
        vm.$parent.closeWs()
        vm.showLogsSpinner = false
        if (doPush) {
          vm.$router.push({name: 'Sync'})
        }
        vm.getList()
      },
      onCopy: function () {
        // FIXME this popup displays behind the modal
        // let vm = this
        // vm.$Simplert.open({ title: 'Copied', message: 'Copied to your clipboard!', type: 'success' })
      },
      resizeEditor: function () {
        var newHeight = window.innerHeight
        var newWidth = 0
        if (this.$refs.resultsRef) {
          newWidth = this.$refs.resultsRef.clientWidth
        }
        this.textBlockWidth = Math.round(newWidth * 90 / 100)
        this.textBlockHeight = Math.round(newHeight * 60 / 100)
      },
      clickCreateNew: function () {
        let vm = this
        vm.$router.push({name: 'SyncForm'})
      },
      clickGuide: function () {
        let vm = this
        vm.$router.push({name: 'SyncGuide'})
      },
      clickDashboards: function () {
        let vm = this
        vm.$router.push({name: 'SyncDashboard'})
      },
      clickDelete: function (selection) {
        let vm = this
        vm.selection = selection
        vm.modalDeleteShow = true
        vm.heliumAppUuidForDelete = selection.id
      },
      deleteWithWebsocket: function () {
        let vm = this
        let wsUrl = vm.$parent.httpUrlToWebSockeUrl(vm.getSyncUrl() + 'ws')
        vm.$parent.loading = true
        vm.$parent.socket = new WebSocket(wsUrl)
        vm.$parent.socket.onopen = function () {
          vm.$parent.socket.onmessage = function (response) {
            // console.log(response.data)
            var json = JSON.parse(response.data)
            vm.feedbackMessage = json.value
            vm.showFeedback = true
          }
          vm.$parent.socket.onclose = function (response) {
            vm.getList()
            vm.$parent.loading = false
          }
          let websocketRequest = {}
          websocketRequest['appId'] = vm.heliumAppUuidForDelete
          websocketRequest['type'] = 'DESTROY'
          websocketRequest['config'] = null
          vm.$parent.socket.send(JSON.stringify(websocketRequest))
        }
      },
      modalDeleteAction: function () {
        let vm = this
        vm.modalDeleteShow = false
        vm.deleteWithWebsocket()
        vm.heliumDeleteConfirm = null
      },
      modalDeleteClose: function () {
        let vm = this
        vm.modalDeleteShow = false
        vm.heliumDeleteConfirm = null
      },
      toggleExpand: function () {
        let vm = this
        vm.expand = vm.expand !== true
      },
      clickRefresh: function () {
        let vm = this
        vm.modalLogClose()
        vm.getList()
      },
      formatEpoch: function (value) {
        var epoch = parseInt(value)
        var valueConverted = new Date(epoch)
        return valueConverted.toLocaleString()
      }
    },
    created () {
      let vm = this
      vm.getList()
      vm.resizeEditor()
      window.addEventListener('resize', vm.resizeEditor)
      window.addEventListener('keydown', function (e) {
        if (e.keyCode === 27) {
          vm.modalLogClose()
          vm.modalInfoClose()
          vm.modalDeleteClose()
        }
      })
    },
    beforeDestroy: function () {
      let vm = this
      window.removeEventListener('resize', vm.resizeEditor)
    },
    watch: {
      'enabledRadio': function (newValue) {
        let vm = this
        if (vm.syncConfig !== null) {
          if (newValue === 'Enabled') {
            vm.syncConfig.enabled = true
          } else {
            vm.syncConfig.enabled = false
          }
        }
      },
      'heliumAppUuidForDelete': function (newValue) {
        let vm = this
        let tmp = null
        vm.$parent.apps.forEach(function (key) {
          if (key.id === newValue) {
            tmp = key.name
          }
        })
        vm.heliumAppNameForDelete = tmp
      },
      'heliumDeleteConfirm': function (newValue) {
        let vm = this
        if (newValue === 'DELETE') {
          vm.deleteDisabled = false
        } else {
          vm.deleteDisabled = true
        }
      }
    },
    computed: {
      numLogs: function () {
        return this.logs.length
      },
      textBlock: function () {
        return this.logs.join('\n') + '\n'
      }
    }
  }
</script>

<style scoped>
  .card-block-watermark {
    font-size: 2rem;
    position: absolute;
    bottom: 5px;
    right: 5px;
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// Sync.vue?7e7f66c6